import { FormattedMessage } from 'react-intl';

export const useGetOrganisationsByUserIdMessages = {
  'useGetOrganisationsByUserId.fetch.unexpectedError': (
    <FormattedMessage
      id="useGetOrganisationsByUserId.fetch.unexpectedError"
      defaultMessage="Error loading organisations associated to the user. Please refresh your browser or contact support."
    />
  ),
};
